export default {
    slug: 'sms',
    settingsRoutes: [
        {
            path: 'sms',
            name: 'settings-sms',
            component: () => import('@modules/Sms/Resources/js/pages/settings/SmsSettings.vue'),
            props: true
        }
    ],
    settings: () => [
        {
            title: i18n.t('Administration'),
            order: 30,
            items: [
                {
                    title: i18n.t('SMS'),
                    icon: 'message-text',
                    route: 'settings-sms',
                    admin: true,
                    module: 'sms'
                }
            ]
        }
    ]
};
